module.exports = __webpack_public_path__ + "img/minister.c37be641.svg";